import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGarage: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="garage"><path fillRule="evenodd" clipRule="evenodd" d="M11.1157 3.14868C11.6619 2.82886 12.3381 2.82886 12.8843 3.14868L21.1343 7.97976C21.6705 8.29375 22 8.86852 22 9.48989V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V9.48989C2 8.86853 2.32949 8.29375 2.86569 7.97976L11.1157 3.14868ZM7.5 18.5H16.5V16H7.5V18.5ZM7.5 14.5H16.5V12.25C16.5 12.1119 16.3881 12 16.25 12H7.75C7.61193 12 7.5 12.1119 7.5 12.25V14.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconGarage;
